import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ConfirmationModal } from '../../../components';
import {
  AcceptedConversationsIcon,
  MoreIcon,
  TimerIcom,
  TrashIcon,
} from '../../../assets/icons';
import { removeOperatorStart } from '../../../redux/operators/operators.actions';
import { useModal } from '../../../hooks';
import EditOperatorModal from '../EditOperatorModal';
import OperatorAvatar from '../../OperatorAvatar';
import { splitPriceByThree } from '../../../utils';
import useTranslation from 'hooks/useTranslation';
import { replaceKeyWithValue } from 'utils/text';

const mapState = ({ userData }) => ({
  profile: userData.profile,
});

const OperatorItem = ({
  id,
  fullName,
  position,
  workTime,
  accepted,
  imageUrl,
  isCreator,
  accessLevel,
  isOnline,
}) => {
  const { profile } = useSelector(mapState);
  const dispatch = useDispatch();
  const [visible, toggle] = useModal();
  const { userId, isCreatorAdmin } = profile;
  const { getTranslation } = useTranslation('OPERATORS');
  const { t } = getTranslation();

  const handleRemoveOperator = (event) => {
    if (event) event.preventDefault();
    dispatch(removeOperatorStart({ id, fullName }));
  };

  const openConfirmationModal = (event) => {
    if (event) event.preventDefault();
    toggle();
  };

  const renderSettingsOverlay = (
    <div className='operators__list__inner__info__vertical flex-as-e grid grid-pi-c'>
      <img src={MoreIcon} alt='' />
      <div className='operators__list__inner__info__vertical__menu '>
        <ul className='operators__list__inner__info__vertical__menu__inner'>
          <li>
            <EditOperatorModal operatorId={id} />
          </li>
          {!isCreator && isCreatorAdmin && (
            <li>
              <a
                href='#/'
                className='flex'
                rel='noopener noreferrer'
                onClick={openConfirmationModal}
              >
                <img src={TrashIcon} alt='' />
                <p> {t('DELETE_OPERATOR')} </p>
              </a>
              <ConfirmationModal
                message={replaceKeyWithValue(
                  t('DELETE_OPERATOR_CONFIRM'),
                  'name',
                  fullName
                )}
                onConfirm={handleRemoveOperator}
                visible={visible}
                toggle={toggle}
              />
            </li>
          )}
        </ul>
      </div>
    </div>
  );

  const renderOperatorProfile = (
    <>
      <OperatorAvatar
        avatarId={id}
        imageUrl={imageUrl}
        fullName={fullName}
        wrapperClass={`operators__list__inner__info__img ${
          isOnline ? 'online' : 'ofline'
        }`}
      />
      <div className='operators__list__inner__info__name'>{fullName}</div>
      <div className='operators__list__inner__info__title'>
        {!position || position == '' ? (
          <i>{t('OPERATOR_WITHOUT_TITLE_LABEL')}</i>
        ) : (
          position
        )}
      </div>
    </>
  );

  const renderOperatorStatistic = (
    <div className='operators__list__inner__info__stats flex'>
      <div className='operators__list__inner__info__stats__inner'>
        <img src={TimerIcom} alt='' />
        <p className='operators__list__inner__info__stats__inner__title'>
          {t('WORKING_HOURS')}
        </p>
        <p className='operators__list__inner__info__stats__inner__value'>
          {workTime}
        </p>
      </div>
      <div className='operators__list__inner__info__stats__inner'>
        <img src={AcceptedConversationsIcon} alt='' />
        <p className='operators__list__inner__info__stats__inner__title'>
          {t('ACCEPTED')}
        </p>
        <p className='operators__list__inner__info__stats__inner__value'>
          {splitPriceByThree(accepted.totalAccepted)}
        </p>
      </div>
    </div>
  );

  return (
    <div className='operators__list__inner__info flex flex-column flex-ai-c'>
      {((!isCreatorAdmin && accessLevel === 'user') ||
        id === userId ||
        isCreatorAdmin) &&
        renderSettingsOverlay}
      {!isCreatorAdmin && accessLevel === 'admin' && id !== userId && (
        <div style={{ height: '2rem' }}></div>
      )}
      {renderOperatorProfile}
      {renderOperatorStatistic}
    </div>
  );
};

export default OperatorItem;
